export default __webpack_public_path__ + "static/media/224.b1875ec7.jpg";